import { render } from "./LiteratureInfoTable.vue?vue&type=template&id=f2dbbf6e&ts=true"
import script from "./LiteratureInfoTable.vue?vue&type=script&lang=ts"
export * from "./LiteratureInfoTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__